import React, { useContext } from 'react';
import { Button, ButtonGroup, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row, UncontrolledAlert } from "reactstrap";
import { UserContext, } from "../utils";

export default function ConfirmModal(props) {
   const userCtx = useContext(UserContext);
   const modalClassName = userCtx.theme ? `${userCtx.theme}` : "lightTheme";
   return (
      <Modal
         id="confirm-delete"
         isOpen={props.confirmDelete}
         contentClassName={props.modalClassName || modalClassName}
      >
         <ModalHeader children={props.header || "Confirm Delete"} />
         <ModalBody>
            {props.errorMessage ? (
               <Row className="mt-3">
                  <Col>
                     <UncontrolledAlert className={props.errorMessage.flavor}>{props.errorMessage.text}</UncontrolledAlert>
                  </Col>
               </Row>
            ) : null}
            {props.warningMessage}
         </ModalBody>
         <ModalFooter>
            <ButtonGroup>
               <Button
                  children={props.yesText || "Yes"}
                  className="button-success"
                  onClick={props.approveConfirmDelete}
                  disabled={props.disabled}
               />
               {/* acknowledgeOnly turns this into a hard stop: one dismiss button (approveConfirmDelete),
                   no way to proceed. Omit it for the normal two-button confirm. */}
               {props.acknowledgeOnly ? null : (
                  <Button
                     children={props.noText || "No"}
                     className="button-danger"
                     onClick={props.declineConfirmDelete}
                     disabled={props.disabled}
                  />
               )}
            </ButtonGroup>
         </ModalFooter>
      </Modal>
   );
}